import React from "react";

export default function OrchestraIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">
  <g id="Gruppe_158" data-name="Gruppe 158" transform="translate(-378 -1749)">
    <rect id="Rechteck_309" data-name="Rechteck 309" width="128" height="128" transform="translate(378 1749)" fill="none"/>
    <g id="Gruppe_157" data-name="Gruppe 157" transform="translate(-3455.436 72.758)">
      <path id="Pfad_1302" data-name="Pfad 1302" d="M-9252.939-3067.994c-4.3-2.151-21.508,34.413-43.016,34.413s-38.714-36.563-43.016-34.413,25.81,43.015,25.81,43.015v43.016l17.206-8.6,17.206,8.6v-43.016S-9248.638-3065.843-9252.939-3067.994Z" transform="translate(13193.392 4771.754)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
      <rect id="Rechteck_308" data-name="Rechteck 308" width="27.96" height="2.151" transform="matrix(-0.875, 0.485, -0.485, -0.875, 3881.452, 1692.573)"/>
      <g id="Ellipse_110" data-name="Ellipse 110" transform="translate(3887.105 1714.382)" fill="none" stroke="currentColor" strokeWidth="3">
        <circle cx="10.314" cy="10.314" r="10.314" stroke="none"/>
        <circle cx="10.314" cy="10.314" r="8.814" fill="none"/>
      </g>
      <path id="Pfad_1303" data-name="Pfad 1303" d="M-9448.9-3020v9.049L-9467-3020v9.049Z" transform="translate(13355.37 4761.013)"/>
    </g>
  </g>
</svg>;
}